export const verificationProfileURLs = {
  disableWidgetDisplay: (userid: number): string =>
    `/v1/verification-profile/${userid}/disable-widget-display`,
  status: (userId: number): string =>
    `/v1/verification-profile/${userId}`,
  setExpressVerification: (userId: number): string =>
    `/v1/verification-profile/${userId}/set-express-verification-form-passed`,
};
